import { Image, Modal } from "antd";
import { styled } from "styled-components";

export const CustomModal = styled(Modal)`
  .ant-modal-content {
    background-color: transparent !important;
    border: 0 !important;
  }
  .ant-modal-body {
    background-color: transparent !important;
    padding: 0 !important; 
  }
  .ant-modal-close {
    display: none;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  overflow:auto;
`;

export const ModalCardWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  z-index: 1001;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageContainerStyled = styled.div<{ $backgroundColor: string }>`
  display: flex; 
  justify-content: center; 
  align-items: center; 
  width: 100%;
  padding: 12px;
  aspect-ratio: 1;
  position: relative;
  background-color: ${props => props.$backgroundColor};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  max-width:500px;
  max:height: 500px;
  background-color: ${props => props.$backgroundColor};
`;

const ImageStyled = styled.img`
  border-radius: 12px;
  width: 100%;
  max-width: 199px;
  height: 100%;
  max-height: 217px;
  object-fit: fill;
`;

const DetailStyled = styled.div<{ $backgroundColor: string }>`
  display: flex;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 199px;
  width: 100%;
  max-width: 223px;
  height: 100%;
  gap: 12px;
  align-self: stretch;
  border-radius: 0px 0px 16px 16px;
  text-align: left;
  background-color: ${props => props.$backgroundColor};
`;

const DividerStyled = styled.div<{ $backgroundColor: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  background-color: transparent;
`;

const DashContainerStyled = styled.div<{ $backgroundColor: string }>`
  width: calc(100% - 24px); 
  height: 24px;
  background-color: ${props => props.$backgroundColor};
`;

const DashStyled = styled.div<{ $backgroundColor: string }>`
  height: 1px; 
  width: 100%;
  border: none;
  background: linear-gradient(to right, transparent 50%, rgba(24, 55, 68, 0.30) 60%);
  background-size: 20px 34px;
  background-repeat: repeat-x;
  position: relative;
  z-index: 1;
  margin: 12px 0;
  background-color: ${props => props.$backgroundColor};
`;


export const ImageContainerStyledModal = styled.div<{ $backgroundColor: string }>`
  display: flex; 
  justify-content: center; 
  align-items: center; 

  background-color: ${props => props.$backgroundColor};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const DetailContainerModal = styled.div<{ $backgroundColor: string }>`
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center; 
  width: 352px;
  height: auto; 
  background-color: ${({ theme }) => theme?.colors?.common?.white};
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: ${props => props.$backgroundColor};
`;

export const DescriptionStyledModal = styled.div<{ $backgroundColor: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: auto;
  height: auto;
  border-radius: 0px 0px 24px 24px;
  background-color: ${props => props.$backgroundColor};
  
    padding-top: 12px;
`;

export const ValidityText = styled.div`
  margin: 8px 12px;
  font-size: 0.875rem;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-weight: normal;
  text-align: center;
`;

export const ImageStyledModal = styled(Image)`
  border-radius: 12px 12px 0px 0px;
  object-fit: fill;
`;

export const StyledQRCodeImage = styled.img`
  width: 220px;
  height: 220px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: block;
  margin: 0 auto;
`;

export const QRImageContainer = styled.div<{ $backgroundColor: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 4px;
  background-color: ${props => props.$backgroundColor};
  border-radius: 0px 0px 16px 16px !important;
  padding-top: 32px;
`;

export const DetailStyledModal = styled.div<{ $backgroundColor: string }>`
  display: flex;
  width: 352px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-radius: 0px 0px 24px 24px;
  background-color: ${props => props.$backgroundColor};
  padding-bottom: 32px;
`;

export const DividerStyledModal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  padding: 0px 20px;
  margin: 0px -20px;
  max-width: 392px;
  height: 24px;
`;

export const DashContainerStyledModal = styled.div<{ $backgroundColor: string }>`
  width: calc(100% - 24px); 
  background-color: ${props => props.$backgroundColor};
`;

export const DashStyledModal = styled.div`
  height: 1px; 
  width: 100%;
  border: none;
  background: linear-gradient(to right, transparent 50%, rgba(255, 255, 255, 0.20) 60%);
  background-size: 26px 34px;
  background-repeat: repeat-x;
  position: relative;
  z-index: 1;
  margin: 12px 0px;
`;

const Title = styled.div`
  min-height: 32px;
  align-self: stretch;
  overflow: hidden;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  white-space: normal;
  font-family: "Red Hat Display", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  display: -webkit-box;
`;

const Description = styled.div`
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "Red Hat Display", sans-serif;
  font-size: 12px;
  font-style: normal;
  align-self: stretch;
  font-weight: 400;
  line-height: normal;`

  const EllipseLeft = ({ color }: { color: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="25" viewBox="0 0.6 12 25" fill={color}>
      <path fillRule="evenodd" clipRule="evenodd" 
      d="M12 0.75H0C6.62742 0.75 12 6.12258 12 12.75C12 19.3774 6.62742 24.75 0 24.75H12V12.75V0.75Z" 
      fill={color}/>
    </svg>
  );
  
  const EllipseRight = ({ color }: { color: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="25" viewBox="0 0.6 12 25" fill={color}>
      <path fillRule="evenodd" clipRule="evenodd" 
      d="M-1.90735e-06 24.75L12 24.75C5.37258 24.75 -1.43766e-06 19.3774 -8.58275e-07 12.75C-2.78888e-07 6.12258 5.37258 0.750001 12 0.750002L1.90798e-07 0.750001L-8.58275e-07 12.75L-1.90735e-06 24.75Z" 
      fill={color}/>
    </svg>
  );

export const ChipOverlay = styled.div`
  position: absolute;
  bottom: 20px;
  z-index: 1;
`;

export {
  DashContainerStyled,
  ImageContainerStyled,
  DividerStyled,
  DashStyled,
  EllipseLeft,
  EllipseRight,
  ImageStyled,
  DetailStyled,
  Title,
  Description,
};

